/**
 * @generated SignedSource<<69a051985d34ad8ef4838c67bcaa467f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedAuctionClosed_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PriceDisplay_item">;
  readonly " $fragmentType": "PdpSharedAuctionClosed_item";
};
export type PdpSharedAuctionClosed_item$key = {
  readonly " $data"?: PdpSharedAuctionClosed_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedAuctionClosed_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionClosed_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "61342e9185d6414c6e13d191eb77bcef";

export default node;
